import type { TourSpec } from "./types";

export const inventoryTour: TourSpec = {
  id: "inventory",
  version: 2,
  buildSteps: (t) => [
    {
      target: '[data-tour="inventory-selling-realms"]',
      title: t("inventory.realms.title"),
      content: t("inventory.realms.body"),
      placement: "bottom",
      skipBeacon: true,
    },
    {
      target: '[data-tour="inventory-csv-input"]',
      title: t("inventory.csv.title"),
      content: t("inventory.csv.body"),
      placement: "top",
    },
    {
      target: '[data-tour="inventory-analyze-button"]',
      title: t("inventory.analyze.title"),
      content: t("inventory.analyze.body"),
      placement: "top",
    },
    {
      target: '[data-tour="inventory-results-table"]',
      title: t("inventory.results.title"),
      content: t("inventory.results.body"),
      placement: "top",
    },
    {
      target: '[data-tour="row-actions-menu"]',
      title: t("rowActions.title"),
      content: t("rowActions.body"),
      placement: "bottom-start",
    },
    {
      target: '[data-tour="inventory-csv-export"]',
      title: t("inventory.export.title"),
      content: t("inventory.export.body"),
      placement: "top",
    },
  ],
};
